import React, { useState } from 'react';
import './Founder.css';

const credentials = [
  { label: 'Graduate — Mumbai University', icon: <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="#1D4ED8" strokeWidth="1.5"><path d="M2 4h12v8H2z" /><path d="M5 4V3h6v1" /><path d="M5 8h6" /></svg> },
  { label: 'Six Sigma Certification', icon: <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="#1D4ED8" strokeWidth="1.5"><circle cx="8" cy="8" r="6" /><path d="M5 8l2 2 4-4" /></svg> },
  { label: 'General Management — Strategic Alliances & Business Development', icon: <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="#1D4ED8" strokeWidth="1.5"><path d="M8 2L2 5v6l6 3 6-3V5L8 2z" /></svg> },
];

const Founder = () => {
  const [imgError, setImgError] = useState(false);

  return (
    <section id="founder" className="sec">
      <div className="w">
        <div className="rv">
          <div className="eye">Leadership</div>
          <h2 className="sh">Meet the <span>Founder</span></h2>
        </div>
        <div className="fg">
          <div className="rv d1">
            {!imgError ? (
              <div className="fpf">
                <img
                  src="/Founder1.jpeg"
                  alt="Pradeep Singh — Founder of StratX"
                  onError={() => setImgError(true)}
                />
                <div className="fpo">
                  <div className="fpnc">
                    <div className="fpnn">Pradeep Singh</div>
                    <div className="fpnt">Founder &amp; Managing Director, StratX</div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="ffb">
                  <div className="ffi">PS</div>
                </div>
                <div className="fpnc fpnc-fallback">
                  <div className="fpnn">Pradeep Singh</div>
                  <div className="fpnt">Founder &amp; Managing Director, StratX</div>
                </div>
              </>
            )}
          </div>
          <div className="rv d2">
            <p className="fin">
              Pradeep Singh is the founder of StratX — leading a team of business development experts who help companies penetrate and scale in competitive markets.
            </p>
            <div className="fb">
              <p>
                With 15+ years of leadership experience in multinational corporations, Pradeep brings a strong focus on business development management and sales strategies. His expertise spans corporate strategy, operational excellence, and cross-border market development.
              </p>
              <p>
                Over 5+ years of dedicated international business development in India and the Middle East has given Pradeep deep expertise across diverse industries and market segments. He has worked with 50+ companies — guiding entry strategies, start-ups, value proposition design, and the international expansion of Indian companies.
              </p>
            </div>
            <div className="fcs">
              {credentials.map((cred) => (
                <div className="fc" key={cred.label}>
                  <div className="fci">{cred.icon}</div>
                  <div className="fct">{cred.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
